import { render } from "./CoinSelect.vue?vue&type=template&id=2bb2422a&scoped=true"
import script from "./CoinSelect.vue?vue&type=script&lang=js"
export * from "./CoinSelect.vue?vue&type=script&lang=js"

import "./CoinSelect.vue?vue&type=style&index=0&id=2bb2422a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb2422a"]])

export default __exports__